import React, { useState } from 'react';
import { BellOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { NotificationsOverlay } from '@app/components/header/components/notificationsDropdown/NotificationsOverlay/NotificationsOverlay';
import { useOrderNotifications } from '@app/contexts/OrderNotificationContext';
import { HeaderActionWrapper } from '@app/components/header/Header.styles';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';

export const NotificationsDropdown: React.FC = () => {
  const [isOpened, setOpened] = useState(false);
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useOrderNotifications();

  return (
    <BasePopover
      trigger="click"
      content={
        <NotificationsOverlay
          notifications={notifications}
          markAsRead={markAsRead}
          markAllAsRead={markAllAsRead}
        />
      }
      onOpenChange={setOpened}
    >
      <HeaderActionWrapper>
        <BaseButton
          type={isOpened ? 'ghost' : 'text'}
          icon={
            <Badge count={unreadCount} offset={[4, -4]}>
              <BellOutlined style={{ fontSize: '1.5rem' }} />
            </Badge>
          }
        />
      </HeaderActionWrapper>
    </BasePopover>
  );
};
